import { render, staticRenderFns } from "./ad.vue?vue&type=template&id=06479c67&scoped=true&"
import script from "./ad.vue?vue&type=script&lang=js&"
export * from "./ad.vue?vue&type=script&lang=js&"
import style0 from "./ad.vue?vue&type=style&index=0&id=06479c67&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06479c67",
  null
  
)

export default component.exports